module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-bar",
    style: (_vm.styleNotification)
  }, [_c('table', {
    style: (_vm.styleTable)
  }, [_c('tr', [_c('td', {
    staticClass: "side-col"
  }), _vm._v(" "), _c('td', {
    staticClass: "large-col"
  }, [_c(_vm.htmlText, {
    tag: "component"
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "side-col"
  }, [_c('a', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.hide($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fdbd970","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationBar.vue
// module id = 476
// module chunks = 0